import React from 'react';
import './Recovery.scss';
import { Icon } from '../../../../components/common/IconLibrary';

interface RecoveryProps {
  onBack: () => void;
}

const Recovery: React.FC<RecoveryProps> = ({ onBack }) => {
  return (
    <div className="lp-result">
      <div className="lp-result__icon lp-result__icon--success">
        <Icon iconName="check" iconColor="orange" size={36} />
      </div>
      <h3 className="lp-result__title">¡Correo enviado!</h3>
      <p className="lp-result__message">
        Te hemos enviado un enlace para restablecer tu contraseña. Revisa tu bandeja de entrada.
      </p>
      <button className="lp-result__action" onClick={onBack}>
        Volver al inicio de sesión
      </button>
    </div>
  );
};

export default Recovery;